import { useQueryClient } from '@tanstack/react-query';

import { API_CACHE_KEYS } from '@/features/api/constants/cache';
import { useGrapevineGroupEventsApi } from '@/features/api/hooks/grapevine-group-events/useGrapevineGroupEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';

export const useAddAdminStatus = (groupId: string) => {
  const queryClient = useQueryClient();
  const api = useGrapevineGroupEventsApi();

  return useApiMutation({
    mutationFn: (memberId: string) =>
      api.onAddGroupAdminRequest({
        clientGroupAddGroupMembershipAdminRequest: {
          groupId,
          membershipAdminIdToAdd: memberId
        }
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [API_CACHE_KEYS.GROUP_ADMINS, groupId]
      });
    }
  });
};
